import { initializeAxiosRequestInterceptor } from '@sit/client-shared';
import { initializeAuthCallbacks } from '@sit/openapi';
import { authStore } from '@web/auth/auth-store';
import { useEffect } from 'react';
import { useUpdateAccessToken } from '../auth/use-update-access-token';

export function useInitializeClientShared() {
  const setToken = useUpdateAccessToken();
  useEffect(() => {
    initializeAuthCallbacks({
      getToken: () => authStore.getToken() || undefined,
      getRefreshToken: () => authStore.getRefreshToken() || undefined,
      setToken: (token) => {
        void setToken(token);
      },
      onLogout: () => {
        authStore.logout();
      },
      platform: 'web',
    });
  }, [setToken]);
  useEffect(() => {
    initializeAxiosRequestInterceptor();
  }, []);
}
